import * as React from "react";
import { FunctionComponent } from "react";
import ValidationSummaryViewModel, {
  ChargeRegistrationStatus,
} from "../../viewModels/paymentValidation/validationSummaryViewModel";
import { observer } from "mobx-react-lite";
import { Badge } from "react-bootstrap";
import { IconType } from "@edaz/edazkit/Icon";
import Button from "@edaz/edazkit/Button/index";
import ValidationCard from "./validationCard";
import classNames from "classnames";

export interface NoRegistrationCardProps {
  vm: ValidationSummaryViewModel;
}

const NoRegistrationCard: FunctionComponent<NoRegistrationCardProps> = observer(props => {
  const { vm } = props;
  const status = vm.status;

  if (![ChargeRegistrationStatus.invalid, ChargeRegistrationStatus.possibleExempted].includes(status)) {
    return null;
  }

  let badges;
  if (status === ChargeRegistrationStatus.invalid) {
    badges = (
      <Badge className="badge-lg mb-1" pill={false} variant="danger-inverted">
        {vm.ta("invalid")}
      </Badge>
    );
  }

  return (
    <ValidationCard title={vm.vehicleInfo} badges={badges}>
      <h5
        className={classNames("mt-2", "font-weight-normal", {
          "text-danger": status === ChargeRegistrationStatus.invalid,
          "text-info": status === ChargeRegistrationStatus.possibleExempted,
        })}>
        {vm.ta(`description.${status}`)}
      </h5>
      {status === ChargeRegistrationStatus.possibleExempted &&
        vm.possibleExemptionReason &&
        vm.possibleExemptionReason.map((reason, index) => {
          return (
            <div key={index} className="text-muted">
              {vm.ta(`note.${vm.status}.${reason}`)}
            </div>
          );
        })}
      {vm.upcomingCharges.length > 0 && (
        <Button iconLeft={IconType.ShoppingCart} iconLeftAlign={"right"} onClick={vm.buy} className={"d-block mt-2"} block>
          {vm.translate("buy")}
        </Button>
      )}
    </ValidationCard>
  );
});

export default NoRegistrationCard;
